<template>
  <div>

    <editor id="tinymce" v-model="value" :init="init" ></editor>
    <!-- <uploadVideo ref="uploadvideo" :dialogVisible=dialogVisibles  @getvideoUrl="geturl" @changestatus = 'changesta'></uploadVideo> -->
    <div class='zheMask' v-if="maskShow" >
      <div v-loading="maskShow" element-loading-text="正在上传"
           element-loading-spinner="el-icon-loading" class="loading"></div>
    </div>
  </div>
</template>

<script>
// import uploadVideo from './uploadvideo'
import {upload} from '@/api/workCollect/index'
// 引入基础文件：

import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/icons/default/icons'
import 'tinymce/themes/silver'
import 'tinymce/plugins/image'// 插入上传图片插件
import 'tinymce/plugins/link'// 插入链接
import 'tinymce/plugins/code'// 插入代码
import 'tinymce/plugins/preview'// 插入预览
import 'tinymce/plugins/media'// 本地npm安装后，提示找不到media插件，加入这个引用。
// import './index'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/autoresize'
export default {
  name: 'tinymce',
  components: {
    Editor
    //  uploadVideo
  },
  props: {
    curValue: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      dialogVisibles: false,
      loading: false,
      init: this.inits(),
      value: this.curValue,
      maskShow: false
    }
  },
  mounted () {
    tinymce.init({})
    console.log(tinymce.activeEditor, 'mjs')
  },

  watch: {
    curValue (newValue) {
      this.value = newValue
    },
    // 读取输入框内的数据
    value (newValue) {
      this.$emit('input', newValue)
    }

  },
  methods: {
    inits () {
      let that = this
      return {
        language_url: process.env.NODE_ENV === 'production' ? location.origin + '/dist/static/tinymce/langs/zh_CN.js' : '../../../static/tinymce/langs/zh_CN.js', // 语言包的路径
        language: 'zh_CN', // 语言
        skin_url: process.env.NODE_ENV === 'production' ? location.origin + '/dist/static/tinymce/skins/ui/oxide' : '../../../static/tinymce/skins/ui/oxide', // skin路径
        // height: 380, // 编辑器高度
        branding: false, // 是否禁用“Powered by TinyMCE”
        menubar: true, // 顶部菜单栏显示
        elementpath: false, // 禁用编辑器底部的状态栏
        paste_data_images: true, // 允许粘贴图像
        // plugins: ['image', 'link', 'code', 'preview', 'media', 'fullscreen', 'indent2em'],
        plugins: ['advlist anchor autolink autosave code codesample colorpicker colorpicker contextmenu directionality emoticons fullscreen hr imagetools insertdatetime link lists nonbreaking noneditable pagebreak paste preview print save searchreplace spellchecker tabfocus table template textcolor textpattern visualblocks visualchars wordcount lineheight indent2em media image autoresize'],
        // toolbar: ['formatselect | bold italic | alignleft aligncenter alignright alignjustify indent2em |bullist numlist outdent indent | lists image media table | removeformat link | code preview | fullscreen|fullscreens'],
        toolbar: ['searchreplace bold italic underline strikethrough alignleft aligncenter alignright styleselect formatselect fontsizeselect fontselect outdent indent indent2em blockquote undo redo removeformat subscript superscript code codesample link  charmap preview anchor pagebreak insertdatetime table emoticons forecolor backcolor fullscreen lineheight imageButton videoButton audioButton media image'],
        images_upload_handler: (blobInfo, success, failure) => {
          let formdata = new FormData()
          formdata.set('file', blobInfo.blob())
          upload(formdata).then(res => {
            console.log(res, 'llll')

            // res.data.data.forEach(item => {
            //   console.log(item.http)
            //   success(item.http)
            // })
            success(res.data.data.http)
          }).catch(err => {
            failure(err)
          })
        },
        file_picker_types: 'media',
        file_picker_callback: function (callback, value, meta) {
          // 文件分类
          var filetype = '.pdf, .txt, .zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .ppt, .pptx'
          // 为不同插件指定文件类型及后端地址
          switch (meta.filetype) {
            case 'image':
              filetype = '.jpg, .jpeg, .png'
              break
            case 'media':
              filetype = '.mkv, .mp4'
              break
            case 'file':
            default:
          }
          // 模拟出一个input用于添加本地文件
          var input = document.createElement('input')
          input.setAttribute('type', 'file')
          input.setAttribute('accept', filetype)
          input.click()
          input.onchange = function () {
            var file = this.files[0]
            that.maskShow = true
            const formData = new FormData()
            formData.append('file', file)
            console.log(formData)

            let myUpload = function (formdata) {
              upload(formdata).then(res => {
                console.log('==============================', res)
                if (res.data.data.status === 1) {
                  that.maskShow = false
                  let videourl = process.env.FILE_ + '/front/' + res.data.data.objectid
                  callback(videourl)
                } else {
                  setTimeout(() => {
                    myUpload(formdata)
                  }, 3000)
                }
              })
            }
            myUpload(formData)
            // upload(formData).then(res => {
            //   console.log('==============================', res)
            //   that.maskShow = false
            //   let videourl = process.env.FILE_BASE_API + '/front/' + res.data.data.objectid
            //   callback(videourl)
            // })
          }
        },
        media_url_resolver: function (data, resolve) {
          try {
            let videoUri = encodeURI(data.url)
            let embedHtml = `<p>
            <span
                class="mce-preview-object mce-object-video"
                data-mce-selected="1"
                data-mce-object="video"
             contenteditable="false"
             data-mce-p-frameborder="no"
             data-mce-p-scrolling="no"
                data-mce-p-controls="controls"
                data-mce-p-controlslist="nodownload"
                data-mce-p-allowfullscreen="allowfullscreen"
                data-mce-html="%20"
                data-mce-p-src=${videoUri} >
                <video src=${data.url} width="100%" height="auto" controls="controls" controlslist="nodownload"
                data-mce-src = ${data.url}
                >
                </video>
            </span>
        </p>
        <p style="text-align: left;"></p>`
            resolve({ html: embedHtml })
          } catch (e) {
            resolve({ html: '' })
          }
        }
        // setup (editor) {
        //   editor.ui.registry.addButton('fullscreens', {
        //     icon: 'icon_video_upload',
        //     tooltip: '视频',
        //     onAction: function () {
        //       console.log(that.dialogVisibles)

        //       that.dialogVisibles = true
        //     }
        //   })
        // }

      }
    },
    chagns () {
      this.dialogVisibles = true
    },
    geturl (url) {
      console.log(url)
      tinymce.activeEditor.setContent(
        `  <p>
               <span class="mce-preview-object mce-object-video" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" data-mce-p-src="${url}" data-mce-html="%20">
                 <video src="${url}" width="100%" controls="controls"></video>
               </span>
              </p>
            `
      )
    },
    changesta (data) {
      console.log(data)
      this.dialogVisibles = data
    }
  }
}
</script>
<style lang="scss" scoped>
#fullToggle{
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 1111111 !important;
  width: 100vw !important;
  height: 100vh !important;
}

.zheMask{
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255,255,255,0.2);
  top: 0;
  left: 0;
   z-index: 130000000111;
  .loading{
    width: 50%;
    height: 50%;
      z-index: 130000000111;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -25vw;
    margin-top: -25vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tinymce/index.vue